<template>
  <div id="device-instruction-page" class="login-page bg-cover bg-center bg-no-repeat">
    <span v-if="back" @click="$setState('setActiveSettings', null)"> <Close icon="back" /> </span>
    <div v-if="$getState('devicetype') === 'android-instruction'">
      <div class="thrive-logo">
        <img :srcset="
          `${$store.state.appUrl}/img/pwa/login/sign-icon.png, ${$store.state.appUrl}/img/pwa/login/sign-icon@2x.png`
        " :src="`${$store.state.appUrl}/img/pwa/login/sign-icon.png`" alt="Thrive Select android Device" />
      </div>

      <h2 class="page-title color-text font-bold text-28 text-text pt-10 tracking-tight text-center">
        {{ $t("Install this webapp to your Home Screen") }}
      </h2>

      <ol>
        <li class="page-subtitle text-left text-12 text-light_grey">
          1. {{ $t("Tap the menu icon (3 dots in upper right corner)") }}
          <img class='intruct-img' :src="`${$store.state.appUrl}/img/pwa/login/android-menu.svg`" />
        </li>
        <li class="page-subtitle text-left text-12 text-light_grey">
          2. {{ $t("Select") }} "{{ $t("Add to Home Screen") }}"
        </li>
        <li class="page-subtitle text-left text-12 text-light_grey">
          3. {{ $t("Click") }} "{{ $t("Add") }}"
        </li>
      </ol>
    </div>
    <div v-if="$getState('devicetype') === 'iphone-instruction'">
      <img class="page-logo" v-if="$getState('corporation')['is']" :src="$getState('corporation')['dark_logo']"
        :alt="corporationTitle" style="width: 50%; margin: 0 auto; margin-top: 50%;" />
      <div v-else class="thrive-logo ios-thrive-logo">
        <img :srcset="
          `${$store.state.appUrl}/img/pwa/login/sign-icon.png, ${$store.state.appUrl}/img/pwa/login/sign-icon@2x.png`
        " :src="`${$store.state.appUrl}/img/pwa/login/sign-icon.png`" alt="Thrive Select Apple Device" />
      </div>
      <h2 class="page-title color-text font-bold text-28 text-text pt-10 tracking-tight text-center">
        {{ $t("Install this webapp to your Home Screen") }}
      </h2>
      <ol>
        <li class="page-subtitle text-left text-12 text-light_grey">1. {{ $t("At the bottom of your phone, click this")
        }} <img class='intruct-img' :src="`${$store.state.appUrl}/img/pwa/login/iphone-menu.svg`" /> {{ $t("icon") }}
        </li>
        <li class="page-subtitle text-left text-12 text-light_grey">2. {{ $t("Add to Home Screen") }}</li>
      </ol>
    </div>
    <Button v-if="!back" type="link" classes="mb-20 signup-btn" :text="$t('Not Now')" route="/login"></Button>
  </div>
</template>


<script>
import Button from "../UI/Button";
import Close from "../UI/Close";
import store from "../../config/store";

export default {
  name: "DeviceInstructionPage",
  props: {
    back: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Button,
    Close,
    store
  },

  mounted() {

  },

  methods: {
    redirectToInstruction: function () {
      this.$setState("devicetype", 'mobiletype');
    }
  }
};
</script>
<style>
.device-instruction-android-back-button {
  top: 32px;
  left: 20px;
}
</style>